// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"759":"4353caa1200fb4c5","5529":"be5c27b85206b4b6","5959":"6fe0bca4709250fa"}[chunkId] + ".js";
};